const rulePolicy = [{
  desc: '查询待审批政策批次数量',
  options: {
    url: '/rulepolicy/getExamineBatchCount',
    method: 'post'
  }
}]
export default rulePolicy



// WEBPACK FOOTER //
// ./src/api/rulepolicy.js